import {DoccliService} from '../../../../providers/DoccliService.js';
const doccliService = new DoccliService();

export default {
    name: "RecapSignError",
     data () {
    return {       
      loading:false,
      typeSignProgress:null,
      token:null,
      callbackUrl:null,
      callbackLibelle:null

    }
  },
  beforeMount: function () {
    this.token = this.$root.token;
    this.callbackUrl = this.$root.callbackUrl;
    this.callbackLibelle = this.$root.callbackLibelle;
    this.typeSignProgress = this.$globalService.getSessionSouscription().typeSignProgress;
    
  },

  methods: {
    signDocument:function(){
      
      this.loading = true;
      var sessionSouscription = this.$globalService.getSessionSouscription();
      if(sessionSouscription == null || !sessionSouscription.doccli_id){
        this.loading = false;
        this.$dialog.error({
          text: "Une erreur s'est produite",
          title: 'Erreur',
          persistent: false,
          actions: {
            false: 'Fermer'
          }
        })
      }
      doccliService.signProgress(sessionSouscription.doccli_id).then(res => { 
        this.loading = false;
        if(res){
          if (res.err !='error') {             
            this.$router.push({name: 'ProgressSign'});
                      
          }else{
            this.$dialog.error({
              text: res.err_msg,
              title: 'Erreur',
              persistent: false,
              actions: {
                false: 'Fermer'
              }
            })
          
          }
        }
      }).catch(error=>{
  
            this.loading = false;
            this.$dialog.notify.error(this.$root.errorMessage, {
                      position: 'bottom-right',
                      timeout: 5000
                    })
          return error;
        })
        
        this.$router.push({name: 'ProgressSign'});

    },
    callback:function(){      
      this.$root.logoutToken(); 
      if(this.callbackUrl)
        window.location.href=this.callbackUrl;      
    },
    webflowsign: function(){
      this.loading = true;
      var sessionSouscription = this.$globalService.getSessionSouscription();
      if(sessionSouscription == null || !sessionSouscription.doccli_id){
        this.loading = false;
        this.$dialog.error({
          text: "Une erreur s'est produite",
          title: 'Erreur',
          persistent: false,
          actions: {
            false: 'Fermer'
          }
        })
      }
      if(!this.$globalService.isDevicePC(this.$device, this.$root.ariadNextShowMode)){
        this.$router.push({name: 'ProgressSign'});
      }else{
        this.$router.push({name: 'QrcodeSign'});
      }
      
      //this.$router.push({path: '/souscription/scandocuments'});
    },
    webflowsignautprev: function(){
      this.loading = true;
      var sessionSouscription = this.$globalService.getSessionSouscription();
      if(sessionSouscription == null || !sessionSouscription.doccli_id){
        this.loading = false;
        this.$dialog.error({
          text: "Une erreur s'est produite",
          title: 'Erreur',
          persistent: false,
          actions: {
            false: 'Fermer'
          }
        })
      }
      doccliService.webflowsignautprev(sessionSouscription.doccli_id).then(res => { 
          this.loading = false;
          if(res){
            if (res.err !='error') {
              this.$globalService.setSessionSouscription('webflow_signature_url',res.params.webflow_signature_url);    
              this.$globalService.setSessionSouscription('active_rdv',res.params.active_rdv);           
              
              if(!this.$globalService.isDevicePC(this.$device, this.$root.ariadNextShowMode)){
                this.$router.push({name: 'ProgressScan'});
              }else{
                this.$router.push({name: 'QrcodeScan'});
              }
                        
            }else{
              this.$dialog.error({
                text: res.err_msg,
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
            
            }
          }
        }).catch(error=>{
    
              this.loading = false;
              this.$dialog.notify.error(this.$root.errorMessage, {
                        position: 'bottom-right',
                        timeout: 5000
                      })
            return error;
          })
      //this.$router.push({path: '/souscription/scandocuments'});
    }
  }
}